import React from 'react';
import { StyleSheet, View, TouchableOpacity, Image } from 'react-native';

import Logo from 'shared/assets/images/logo.png';
import Icon from 'shared/modules/common/components/atoms/Icon';

type Props = {
  showBackButton?: boolean;
  onBackButtonPress?: () => void;
};

const Header = (props: Props) => {
  const { showBackButton, onBackButtonPress } = props;

  return (
    <View style={styles.root}>
      <View>
        {showBackButton && (
          <TouchableOpacity onPress={onBackButtonPress}>
            <Icon name="left-arrow" size="24" />
          </TouchableOpacity>
        )}
      </View>
      <View>
        <Image source={{ uri: Logo }} style={styles.logo} />
      </View>
      <View />
    </View>
  );
};

export default Header;

const styles = StyleSheet.create({
  root: {
    width: '100%',
    height: 44,
    paddingVertical: 8,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 18,
  },
  logo: {
    resizeMode: 'contain',
    aspectRatio: 220 / 80,
    height: 24,
    width: 80,
  },
});
